if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalDialog {
      constructor() {
        super();

        this.options = {
          delay: parseInt(this.getAttribute('delay'), 10) * 1000,
          frequency: parseInt(this.getAttribute('frequency'), 10) * 1000,
        };

        this.openInEditor = this.openInEditor.bind(this);
        this.closeInEditor = this.closeInEditor.bind(this);

        window.addEventListener('load', this.checkOpen.bind(this));

        const emailForm = this.querySelector('.newsletter-form');

        if (emailForm && emailForm.querySelector('[data-subscribed="true"]')) {
          this.persistentHide();
        }
      }

      connectedCallback() {
        if (window.Shopify.designMode) {
          document.addEventListener('shopify:section:select', this.openInEditor);
          document.addEventListener('shopify:section:deselect', this.closeInEditor);
        }
      }

      disconnectedCallback() {
        if (window.Shopify.designMode) {
          document.removeEventListener('shopify:section:select', this.openInEditor);
          document.removeEventListener('shopify:section:deselect', this.closeInEditor);
        }
      }

      checkOpen() {
        if (window.Shopify.designMode) {
          return;
        }

        if (localStorage.getItem('newsletter_modal_persistant_hide_' + this.id) !== null) {
          return;
        }

        if (getCookie('newsletter_modal_hide_' + this.id) !== null) {
          return;
        }

        setTimeout(() => this.open(), this.options.delay);
      }

      close() {
        super.close();
        this.setDismissCookie();
      }

      setDismissCookie() {
        setCookie('newsletter_modal_hide_' + this.id, 1, this.options.frequency);
      }

      persistentHide() {
        localStorage.setItem('newsletter_modal_persistant_hide_' + this.id, 1);
      }

      openInEditor(event) {
        if (this.id != event.detail.sectionId) {
          return;
        }
        this.open();
      }

      closeInEditor(event) {
        if (this.id != event.detail.sectionId) {
          return;
        }
        this.close();
      }
    }
  );
}
